import Ucompare from 'images/logos/pcwLogo.png'
import { DataFileType } from 'types'
import { cardAddonLayout } from 'StandardLayouts/AddonLayouts'
import { baseSplashScreen } from './splashscreenData'
import { baseStoreItems } from './cardItems'
import { conditionData } from './conditionData'
import { baseAddonData } from './addons'
import {
  baseBasketPageOptions,
  baseAddonPageOptions,
  baseStorePageOptions,
} from './pageOptions'

// any object or arrays which are in the baseline, define them here
// as then we can more easily reuse them on the different conditions

const data: DataFileType = {
  conditions: conditionData,

  // All the keys here are for the baseline and will be used if they aren't defined in the condition
  storeLogoSrc: Ucompare,
  storeName: `compare`,
  splash: baseSplashScreen,
  storeItems: baseStoreItems,
  storePageOptions: baseStorePageOptions,
  addonPageOptions: baseAddonPageOptions,
  basketPageOptions: baseBasketPageOptions,
  storeAddons: baseAddonData,
  addonLayout: cardAddonLayout,

  // This is the theming -- this can be changed per condition as well, though we usually won't need to
  theme: {
    banner: {
      color: '#377460',
      backgroundColor: 'white', // 45
      fontSize: 1.5,
    },
    planInfo: {
      backgroundColor: '#377460',
      color: 'white',
    },
    colors: {
      primary: '',
      secondary: '',
      background: '',
      pcwTags: {
        primary: 'red',
        secondary: 'yellow',
        tertiary: 'orange',
      },
    },
    button: {
      color: 'white',
      backgroundColor: 'black',
      activeBackgroundColor: 'white',
      borderRadius: '0px',
    },

    fontSize: 1,
    titleFontSize: 1.2,
    subtitleFontSize: 1,
    priceFontSize: 1.2,

    backgroundColor: '#fff',
    color: '#554344',
    titleColor: '#554344',
    subtitleColor: '#554344',

    fontFamily: 'Calibri, sans-serif',
    featureBullet: '⦾', // \u2022',
  },
}

export default data
